import { theme } from 'antd';
import merge from 'lodash/merge';
import defaultThemeValues from './default';

const darkTheme = merge({}, defaultThemeValues, {
    algorithm: theme.darkAlgorithm,
    token: {
        colorPrimary: '#1c3450',
        colorInfo: '#1c3450',
    },
    components: {
        Layout: {
            headerBg: '#1c3450',
            siderBg: '#1c3450',
        },
        Menu: {
            darkItemBg: '#1c3450',
            darkItemActiveBg: '#162a41',
            darkItemSelectedBg: '#162a41',
            darkItemColor: '#fff',
            horizontalItemHoverBg: '#162a41',
            darkPopupBg: '#1c3450',
        },
        Table: {
            rowSelectedBg: '#1c3450',
            rowSelectedHoverBg: '#162a41',
            rowHoverBg: '#162a41',
        },
        Message: {
            contentBg: '#1f1f1f', // Dark background for messages
            colorText: '#ffffff', // Light text color
        },
        Descriptions: {
            labelBg: '#1f1f1f', // Dark background for labels
        },
        Button: {
            textHoverBg: '#ffffff40',
        },
        Splitter: {
            splitBarSize: 5,
            splitTriggerSize: 10,
            splitBarDraggableSize: 0,
            controlItemBgActive: '#2b5789',
            controlItemBgHover: '#112132',
        },
    },
});

export default darkTheme;
